import { io } from "socket.io-client";

//http://localhost:3002
//https://erp.cafe-mag.ro/
const socket = io(
  process.env.REACT_APP_WEBSOCKET_URL || "https://erp.cafe-mag.ro/",
  {
    transports: ["websocket"],
    extraHeaders: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
    secure: true,
  }
);

export default socket;
